import { useEffect, useState } from "react";

export default function VBCALogo({
  className,
  size = 28,
}: {
  className?: string;
  size?: number;
}) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    setSrc("/lovable-uploads/a9bfc9ae-372c-4921-966e-5bfd19d87920.png");
  }, []);

  return (
    <div
      className={
        "shrink-0 rounded-md ring-1 ring-inset ring-sidebar-border bg-transparent flex items-center justify-center overflow-hidden " +
        (className || "")
      }
      style={{ width: size, height: size }}
      aria-label="VBCA logo"
    >
      {src ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={src} alt="Value Based Care Advisors logo" style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
      ) : (
        <div className="w-full h-full rounded-md bg-sidebar-accent" />
      )}
    </div>
  );
}
























